import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import logoblack from 'src/assets/product-config/logo-black.png'
import { useAuth } from 'src/hooks/auth'
import { Billet } from 'src/pages/payBillsPayInvoice'
import { DefaultLabel } from 'src/pages/receipt/PDF'
import dateToLine from 'src/utils/dateToLine'
import { documentFormatted } from 'src/utils/documentFormatted'
import { ExtractItem } from 'src/utils/extractDescription'
import toLocaleAmount from 'src/utils/toLocaleAmount'

export const Slip: FC<{ data: ExtractItem; closeModal: () => void }> = ({
  data,
  closeModal,
}) => {
  const navigate = useNavigate()
  const billet: Billet = data.data
  const { user } = useAuth()
  useEffect(() => {
    if (!data) {
      navigate('/extract')
    }
  }, [data, navigate])

  const payerName =
    data.direction === 'out'
      ? user.name
      : billet.payment_info.payer_name || 'Desconhecido'
  const payerDocument =
    data.direction === 'out'
      ? user.document
      : billet.payment_info.payer_document || 'Desconhecido'

  return (
    <>
      <div className="w-full h-16 flex px-10 items-center bg-[#191919]">
        <span className="text-white text-xl font-bold">Boleto Bancário</span>
      </div>
      <div className="w-full flex justify-center py-5">
        <img src={logoblack} alt="Logo" className="w-40 h-40" />
      </div>
      <div className="flex w-full justify-between p-10">
        <div>
          <span className="text-zinc-400 text-2xl font-bold">{payerName}</span>
          <p className="text-[#191919] text-5xl font-bold">
            R$ {toLocaleAmount(billet.barcode_details.value)}
          </p>
        </div>
        <span className="font-bold text-lg">
          {dateToLine(billet.barcode_details.due_date)}
        </span>
      </div>
      <div className="flex flex-col px-10 py-4 gap-1">
        <span className="text-zinc-500 font-semibold mb-2 text-3xl">
          Pagador
        </span>
        <DefaultLabel title="NOME" value={payerName} />
        <DefaultLabel
          title="Documento"
          value={documentFormatted(payerDocument)}
        />
      </div>
      <div className="flex flex-col px-10 py-4 gap-1">
        <span className="text-zinc-500 font-semibold mb-2 text-3xl">
          Detalhes do Boleto
        </span>
        <DefaultLabel
          title="Banco"
          value={`${billet.barcode_details.bank_code} - ${billet.barcode_details.bank_name}`}
        />
        <DefaultLabel
          title="Linha Digitável"
          value={billet.barcode_details.digitable_line}
        />
        <DefaultLabel
          title="Código de Barras"
          value={billet.barcode_details.barcode}
        />
      </div>
    </>
  )
}
